import { store } from '@/store';
import * as OrderActions from '@/store/ducks/order/actions';
import { IOrder } from '@/store/ducks/order/types';

import { setLocalOrder } from './setLocalOrder';
import { useLocalOrder } from './useLocalOrder';
import { useWebContext } from './useWebContext';

export const useDefaultOrder: () => IOrder | null = () => {
  const { order } = useWebContext();

  if (order && order.client?.id !== 1) {
    setLocalOrder(order);
    return order;
  }

  const newOrder = useLocalOrder();

  if (newOrder && Object.keys(newOrder).length) {
    store.dispatch(OrderActions.loadSuccess(newOrder));
    return newOrder;
  }

  return null;
};
